import styled from 'styled-components';

export const InputDiv = styled.input`
    overflow: visible;
    border: none;
    outline: none;
    min-width: 0;
    width: 150px;
    height: 16px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.neutral900};
    ${({ customStyle }) => ({ ...customStyle })}
    &::placeholder {
        line-height: 16px;
        overflow: visible;
    }
`;
